import React, { ReactNode } from 'react';
import { Form } from 'antd';
import { ErrorListProps as ErrorListCopyProps } from 'antd/lib/form';

export type ErrorListProps = ErrorListCopyProps & {
  children?: ReactNode;
};

const ProFormErrorList: React.FC<ErrorListProps> = props => {
  const { children, ...resProps } = props;
  return <Form.ErrorList {...resProps}>{children}</Form.ErrorList>;
};

export default ProFormErrorList;
